export var getSubStringFromContent = function (content, regex) {
    var _a, _b;
    return ((_b = (_a = content === null || content === void 0 ? void 0 : content.match) === null || _a === void 0 ? void 0 : _a.call(content, regex)) === null || _b === void 0 ? void 0 : _b[1]) || '';
};
